import { useSupabaseMetrics } from '@/hooks/use-supabase-metrics'
import { useAdminStats, sumForPeriod } from '@/hooks/useAdminStats'
import { MetricCard } from './MetricCard'

export function MetricsDashboard() {
  const { mapsCount, flightsCount, usersCount, isLoading: supabaseLoading, isError: supabaseError } = useSupabaseMetrics()
  const { data: adminStats, isLoading: adminStatsLoading, isError: adminStatsError } = useAdminStats()

  // Calculate dashboard visits for last 7 days from timeseries
  const visitsLastWeek = adminStats?.visits?.dashboard?.timeseries
    ? sumForPeriod(adminStats.visits.dashboard.timeseries, 7)
    : 0

  return (
    <div className="bg-white/[0.02] border border-white/[0.06] rounded-lg p-4">
      <div className="grid grid-cols-4 gap-4">
        <MetricCard label="Total Users" value={usersCount ?? 0} isLoading={supabaseLoading} isError={supabaseError} />

        <MetricCard label="Maps Generated Last Week" value={mapsCount ?? 0} isLoading={supabaseLoading} isError={supabaseError} />

        <MetricCard label="Flights Last Week" value={flightsCount ?? 0} isLoading={supabaseLoading} isError={supabaseError} />

        <MetricCard label="User Visits Last Week" value={visitsLastWeek} isLoading={adminStatsLoading} isError={adminStatsError} />
      </div>
    </div>
  )
}
